var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "School",
    clipPath: "url(#clip0_4361_311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 12V21.75H21V12L12 3L3 12Z",
    fill: "#B5C4D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 3L3 12V20.598C3.3105 20.6145 3.6225 20.625 3.9375 20.625C11.1877 20.625 17.3029 16.2375 19.2352 10.2353L12 3Z",
    fill: "#DAE7F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.25 21.75H21.75V23.25H2.25V21.75Z",
    fill: "#20365B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.75 12L12 0.75L23.25 12H21L12 3L3 12H0.75Z",
    fill: "#D83D59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12 12C13.2426 12 14.25 10.9926 14.25 9.75C14.25 8.50736 13.2426 7.5 12 7.5C10.7574 7.5 9.75 8.50736 9.75 9.75C9.75 10.9926 10.7574 12 12 12Z",
    fill: "#A9BFE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.25 14.25H10.5V21.75H5.25V14.25Z",
    fill: "#D83D59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12 14.25H19.5V19.5H12V14.25Z",
    fill: "#A9BFE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.5 16.5H16.125V14.25H15.375V16.5H12V17.25H15.375V19.5H16.125V17.25H19.5V16.5Z",
    fill: "#5E547A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.375 16.875H7.125V18.375H6.375V16.875Z",
    fill: "#FFDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4361_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3f3f4246c01fe0525a9dcf8439752351.svg";
export { ForwardRef as ReactComponent };